import React from "react";
import { Row, Table } from "react-bootstrap";
import {useSelector } from "react-redux";
import { Frequencies, FrequencyValues,BotTypeName } from "../../../Const";

const QuickStartSetting = (props) => {
  const { bot,t } = props;
  const exchangePair = bot.exchange_pair || {};
  const exchange = exchangePair.exchange || {};
  const pair = exchangePair.pair || {};
  const indicators = bot.bot_indicators || [];
  const stoploss = bot.stop_loss || 0;
  const theme = useSelector((state) => state.settings.selected_theme);
  

  return (
    <Row>
      <Table responsive className={`theme-bg ${theme}`}>
        <thead className="table-heading">
          <tr>
            
            <th>{t("pair")}</th>
            <th>{t("bot-type")}</th>
            <th>{t("strategy")}</th>
            <th>{t("frequency")}</th>
            {/* <th>{t("entry-indicators")}</th>
            <th>{t("exit-indicators")}</th>
            <th>{t("tp")}</th>
            <th>{t("stoploss")}</th> */}
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>{pair && `${pair.from}/${pair.to}`}</td>
            <td>{bot && BotTypeName[bot.type]}</td>
            <td>{bot && bot.strategy}</td>
            <td>
              {bot && Frequencies[FrequencyValues.indexOf(bot.frequency)]}
            </td>
            {/* <td>{entryIndicators}</td>
            <td>{exitIndicators}</td>
            <td>{bot && bot.profit && parseFloat(bot.profit).toFixed(2)}%</td>
            <td>{stoploss}%</td> */}
          </tr>
        </tbody>
      </Table>
    </Row>
  );
};

export default QuickStartSetting;
